// extracted by mini-css-extract-plugin
export default {"Router":"styles_Router__Eer3t","loading":"styles_loading__UDXPf","content":"styles_content__zriAU","footerPadding":"styles_footerPadding__mWaRe"};